/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { CreateSearchResponseDTOFromJSON, DeleteSearchRequestDTOToJSON, PaginatedResponseSearchDTOFromJSON, PaginatedResponseSearchResultDTOFromJSON, RootCategoryResponseDTOFromJSON, SearchRequestDTOToJSON, SearchResultRequestDTOToJSON, UpdateSearchResultDecisionRequestDTOToJSON, UpdateSearchResultDecisionResponseDTOFromJSON, VariationSearchRequestDTOToJSON, } from '../models/index';
/**
 *
 */
export class SearchControllerApi extends runtime.BaseAPI {
    /**
     */
    async cancelSearchRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling cancelSearch().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/search/{id}/cancel`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async cancelSearch(requestParameters, initOverrides) {
        await this.cancelSearchRaw(requestParameters, initOverrides);
    }
    /**
     */
    async createSearchRaw(requestParameters, initOverrides) {
        if (requestParameters['searchRequestDTO'] == null) {
            throw new runtime.RequiredError('searchRequestDTO', 'Required parameter "searchRequestDTO" was null or undefined when calling createSearch().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/search`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchRequestDTOToJSON(requestParameters['searchRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSearchResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async createSearch(requestParameters, initOverrides) {
        const response = await this.createSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async createSearchFromVariationsRaw(requestParameters, initOverrides) {
        if (requestParameters['variationSearchRequestDTO'] == null) {
            throw new runtime.RequiredError('variationSearchRequestDTO', 'Required parameter "variationSearchRequestDTO" was null or undefined when calling createSearchFromVariations().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/search/variation`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VariationSearchRequestDTOToJSON(requestParameters['variationSearchRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSearchResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async createSearchFromVariations(requestParameters, initOverrides) {
        const response = await this.createSearchFromVariationsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteSearchRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteSearch().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/search/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteSearch(requestParameters, initOverrides) {
        await this.deleteSearchRaw(requestParameters, initOverrides);
    }
    /**
     */
    async deleteSearchesRaw(requestParameters, initOverrides) {
        if (requestParameters['deleteSearchRequestDTO'] == null) {
            throw new runtime.RequiredError('deleteSearchRequestDTO', 'Required parameter "deleteSearchRequestDTO" was null or undefined when calling deleteSearches().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/search`;
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteSearchRequestDTOToJSON(requestParameters['deleteSearchRequestDTO']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteSearches(requestParameters, initOverrides) {
        await this.deleteSearchesRaw(requestParameters, initOverrides);
    }
    /**
     */
    async getRootCategoriesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/search/root-categories`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => RootCategoryResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async getRootCategories(initOverrides) {
        const response = await this.getRootCategoriesRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getSearchResultsRaw(requestParameters, initOverrides) {
        if (requestParameters['searchResultRequestDTO'] == null) {
            throw new runtime.RequiredError('searchResultRequestDTO', 'Required parameter "searchResultRequestDTO" was null or undefined when calling getSearchResults().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/search/results`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchResultRequestDTOToJSON(requestParameters['searchResultRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseSearchResultDTOFromJSON(jsonValue));
    }
    /**
     */
    async getSearchResults(requestParameters, initOverrides) {
        const response = await this.getSearchResultsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async listSearchesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'].toISOString();
        }
        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'].toISOString();
        }
        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }
        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }
        if (requestParameters['targetMarket'] != null) {
            queryParameters['targetMarket'] = requestParameters['targetMarket'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        if (requestParameters['createdBy'] != null) {
            queryParameters['createdBy'] = requestParameters['createdBy'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/search`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseSearchDTOFromJSON(jsonValue));
    }
    /**
     */
    async listSearches(requestParameters = {}, initOverrides) {
        const response = await this.listSearchesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updateSearchResultDecisionRaw(requestParameters, initOverrides) {
        if (requestParameters['updateSearchResultDecisionRequestDTO'] == null) {
            throw new runtime.RequiredError('updateSearchResultDecisionRequestDTO', 'Required parameter "updateSearchResultDecisionRequestDTO" was null or undefined when calling updateSearchResultDecision().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/search/results/decision`;
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSearchResultDecisionRequestDTOToJSON(requestParameters['updateSearchResultDecisionRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateSearchResultDecisionResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async updateSearchResultDecision(requestParameters, initOverrides) {
        const response = await this.updateSearchResultDecisionRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const ListSearchesStatusesEnum = {
    Pending: 'PENDING',
    Inprogress: 'INPROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Canceled: 'CANCELED'
};
/**
 * @export
 */
export const ListSearchesTargetMarketEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
